import { Environment } from './environment.interface';

export const environment: Environment = {
  production: false,
  apiBaseUrl: 'https://api.metrics-test.mgmt.vortex.metoffice.cloud',
  adminApiBaseUrl: 'https://api.metrics-test.mgmt.vortex.metoffice.cloud',
  noAuthMode: false,
  staticBearerToken: 'MOCK_TOKEN',
  msal: {
    clientId: 'b122f659-af89-4f55-bab0-0c6d01dee430',
    tenantId: '17f18161-20d7-4746-87fd-50fe3e3b6619',
    redirectUri: 'https://metrics-test.mgmt.vortex.metoffice.cloud',
    scopes: {
      // Custom API scopes - requires "Expose an API" configuration in Azure AD
      // Format: {appIdUri}/{scopeName}
      read: ['api://b122f659-af89-4f55-bab0-0c6d01dee430/Metrics.Read'],
      write: ['api://b122f659-af89-4f55-bab0-0c6d01dee430/Metrics.Write']
    },
    protectedResources: {
      metricsApi: {
        endpoint: 'https://api.metrics-test.mgmt.vortex.metoffice.cloud',
        scopes: ['api://b122f659-af89-4f55-bab0-0c6d01dee430/Metrics.Read']
      },
      adminApi: {
        endpoint: 'https://api.metrics-test.mgmt.vortex.metoffice.cloud',
        scopes: ['api://b122f659-af89-4f55-bab0-0c6d01dee430/Metrics.Write']
      }
    }
  },
  banner: {
    enabled: true,
    style: 'professional',
    message: 'Testing Environment',
    subMessage: 'This dashboard is currently in testing. Features and data may be subject to change.',
    dismissible: true,
  },
};
